import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
// absolute inset-0 flex flex-col min-w-0 overflow-y-auto
@Component({
    selector: 'page-404',
    template: `
    <div class="absolute inset-0 flex flex-col min-w-0 overflow-y-auto" cdkScrollable >

    <!-- Main -->
    <div class="flex-auto">
    <div class="w-full flex items-center justify-center h-full min-h-fit" >
        <div class="text-center">
            <img [src]="'404.svg' | imagePath" class="object-contain max-w-[230px] max-h-[230px]" alt="">
            <h1 class="text-center text-[90px] font-semibold text-[#0B0D13] leading-[110px] mt-4">404</h1>
            <p class="font-medium text-[22px] leading-[23px] text-[#7D7F86] text-center">{{noDataLabel}}</p>
            <button class="base_btn primary_btn mt-15" routerLink="/dashboard">Go to Dashboard</button>
        </div>
    </div>
</div>
</div>
  `,
    styles: [],
    host: { class: 'w-full h-full' }
})
export class Error404Component {
    noDataLabel: any = "Page Not Found"
    constructor(private _matDialog: MatDialog) {
        this._matDialog.closeAll()
    }
}
